import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import { TransitionProps } from '@mui/material/transitions';
import { Box, Container, DialogContent, Fade, Paper, Tab, Tabs } from 'src/components/mui';
//@ts-ignore
import React from 'react';
import ThemeConfig from 'src/theme';
import MoreHelp from './components/more-help/MoreHelp';
import Navigation from './components/navigation/Navigation';

type Props = {
  open: boolean;
  onClose: () => void;
  translation?: any;
};

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Fade ref={ref} {...props} />;
});

export function HelpDialog({ translation, open, onClose }: Props) {
  const [value, setValue] = React.useState(0);

  const handleChange = (_, newValue: number) => {
    setValue(newValue);
  };

  return (
    <ThemeConfig>
      <Dialog
        sx={{ zIndex: 9999 }}
        fullScreen
        open={open}
        onClose={onClose}
        TransitionComponent={Transition}
      >
        <Paper
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            px: 1,
          }}
          square
          elevation={5}
        >
          <Box />
          <Tabs textColor="secondary" value={value} onChange={handleChange}>
            <Tab label={translation?.helpNav || 'Navigation'} />
            <Tab label={translation?.helpMore || 'More help'} />
          </Tabs>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
            sx={{ width: '37px', height: '36px' }}
          >
            <i className="fal fa-times" />
          </IconButton>
        </Paper>
        <DialogContent sx={{ display: 'flex', alignItems: 'center' }}>
          <Container sx={{ maxHeight: '90vh' }}>
            {value === 0 && <Navigation translation={translation} />}
            {value === 1 && <MoreHelp translation={translation} />}
          </Container>
        </DialogContent>
      </Dialog>
    </ThemeConfig>
  );
}
